import React from "react";
import { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../../store/userSlice";
import nodeinstance from "../../../../../nodeInstance";

export default function ApplyDateUpdate({
  list,
  PopUp,
  setPopUp,
  url,
  title,
  callBack,
  token,
}) {
  console.log("list", list);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState();
  const [date, setDate] = useState();
  const dateSet = (date) => {
    setDate(date);
  };

  const update = async () => {
    try {
      const res = await nodeinstance.post(
        url,
        list.map((t) => ({
          employee_id: t.emp_id,
          card_apply_date: date,
        })),
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log(res);
      if (res.status == 200) {
        dispatch(
          setAppError({
            msg: res?.data?.message,
            color: "success",
          })
        );
        setPopUp(false);
        callBack();
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
  };

  const handleKeyDown = (event) => {
    event.preventDefault(); // Prevent typing in the input field
  };
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          PopUp ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-lg w-full h-auto  rounded-md bg-white/95 flex  flex-col p-4 relative">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <div className="w-full flex flex-col gap-3 my-3 p-5 items-center place-items-center">
            <div className="flex flex-col gap-1">
              <label className="text-sm font-bold ">{title}</label>
            </div>
          </div>
          <div className="flex flex-col items-center justify-center gap-2 place-items-center">
            <label className="text-sm">APPLY DATE</label>
            <input
              type="date"
              onKeyDown={handleKeyDown}
              id="field2"
              className={`input input-xl h-10 max-w-xl input-bordered focus:outline-none uppercase`}
              required
              onChange={(e) => dateSet(e.target.value)}
            />
          </div>

          <div
            className="flex gap-3 w-full justify-center"
            style={{ margin: 2 }}
          >
            <button
              onClick={() => {
                update();
              }}
              type="submit"
              className="p-3 bg-red text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm" // Decreased padding and font size
            >
              {" "}
              <p>Submit</p>
              {loading ? <CgSpinner className="animate-spin" /> : ""}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
